import { render, staticRenderFns } from "./SandboxM.vue?vue&type=template&id=6a76770e&scoped=true&"
import script from "./SandboxM.vue?vue&type=script&lang=js&"
export * from "./SandboxM.vue?vue&type=script&lang=js&"
import style0 from "./SandboxM.vue?vue&type=style&index=0&id=6a76770e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a76770e",
  null
  
)

export default component.exports